<template>

	<v-card
		flat
	>
		<v-container>

			<v-row>

				<v-col
					md="10"
					sm="12"
					class="pa-0"
				>

					<v-list-item>
						<v-list-item-action class="ma-0 mr-3" v-if="editable">
							<v-checkbox
								title="Pažymėti ištrynimui"
								:disabled="!isMineAtlas(atlas)"
								v-model="checked"
							></v-checkbox>
						</v-list-item-action>
						<v-list-item-avatar
							height="120px"
							width="120px"
							tile
							:class="getImgSrc() ? '' : 'empty'"
						>

							<!--
								TODO FIX: src reikšmė turi būti dinamis atlaso img arba default img
							-->
							<v-img
								dark
								class="atlas-gallery-image"
								:src="getImgSrc()"
								v-if="getImgSrc()"
							>
							</v-img>

						</v-list-item-avatar>

						<v-list-item-content :class="editable? 'ml-3' : null">
							<v-list-item-title class="pb-2">
								{{atlas["title"]}}
							</v-list-item-title>
							<v-list-item-subtitle>
								<div>sukurta: {{atlas["createDate"]}}</div>
								<div>tipas: {{getAtlasType(atlas["atlasType"])}}</div>
								<template v-if="editable">
									<template v-if="isMineAtlas(atlas)">
										<div>pasidalinta: {{getShareType(atlas["shareType"])}}</div>
									</template>
									<template v-else>
										<div>autorius: {{atlas["owner"]}}</div>
									</template>
								</template>
								<template v-else>
									<div>autorius: {{atlas["owner"]}}</div>
								</template>
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

				</v-col>

				<v-col
					md="2"
					sm="12"
					class="text-right d-sm-flex d-md-block paddingRightNone"
				>

					<template v-if="editable">

						<v-list-item dense class="float-right float-sm-none paddingRight5">
							<v-list-item-content class="pa-0">
								<v-list-item-title>
									<router-link v-bind:to="'/atlas/' + atlas['atlasID']" class="link">
										<v-btn icon>
											<v-icon title="Peržiūrėti" size="20">mdi-open-in-new</v-icon>
										</v-btn>
									</router-link>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<template v-if="isMineAtlas(atlas)">

							<v-list-item dense class="float-right float-sm-none paddingRight5">
								<v-list-item-content class="pa-0">
									<v-list-item-title>
										<v-btn
											icon
											v-on:click="shareAtlas(atlas)"
										>
											<v-icon title="Dalintis" size="20">mdi-share-variant</v-icon>
										</v-btn>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>

							<v-list-item dense class="float-right float-sm-none paddingRight5">
								<v-list-item-content class="pa-0">
									<v-list-item-title>
										<v-btn
											icon
											v-on:click="deleteAtlas(atlas)"
											:loading="deleteInAction"
											class="d-none"
										>
											<v-icon title="Šalinti" size="20">mdi-delete</v-icon>
										</v-btn>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>

						</template>

						<template v-else>

							<v-list-item dense class="float-right float-sm-none paddingRight5">
								<v-list-item-content class="pa-0">
									<v-list-item-title>
										<v-btn
											icon
											v-on:click="removeFromSharedWith(atlas)"
											:loading="deleteInAction"
										>
											<v-icon title="Atsisakyti dalinimosi" size="20">mdi-account-minus</v-icon>
										</v-btn>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>

						</template>

					</template>

					<template v-else>
						<v-list-item dense class="float-right float-sm-none paddingRight5">
							<v-list-item-content class="pa-0">
								<v-list-item-title>
									<router-link v-bind:to="'/atlas/' + atlas['atlasID'] + '/view'" class="link">
										<v-btn icon>
											<v-icon title="Peržiūrėti" size="20">mdi-open-in-new</v-icon>
										</v-btn>
									</router-link>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</template>

				</v-col>

			</v-row>
		</v-container>
	</v-card>
</template>

<script>
	import AtlasHelper from "../helpers/AtlasHelper";
	import CommonHelper from "../helpers/CommonHelper";

	export default {
		props: {
			atlas: Object,
			getList: Function,
			editable: Boolean,
			onCheckStatusChange: Function
		},
		data: function(){
			var data = {
				deleteInAction: false,
				checked: false
			};
			return data;
		},
		methods: {
			deleteAtlas: function(atlas){
				var positiveCallback = function(){
					this.deleteInAction = true;
					AtlasHelper.deleteAtlas(atlas["atlasID"]).then(function(){
						this.getList(); // FIXME: o gal užtektų tik pašalinti atlasą iš list'o?..
						this.deleteInAction = false;
					}.bind(this), function(){
						this.$vBus.$emit("show-message", "error");
						this.deleteInAction = false;
					}.bind(this));
				}.bind(this);
				AtlasHelper.deleteAtlasConfirmation(positiveCallback, this.$vBus, atlas);
			},
			shareAtlas: function(atlas){
				this.$vBus.$emit("show-atlas-sharing-form", atlas);
			},
			isMineAtlas: function(atlas){
				return CommonHelper.isMineAtlas(atlas);
			},
			removeFromSharedWith: function(atlas){
				var e = {
					title: "Ar tikrai atsisakyti dalinimosi?",
					message: "Ar tikrai atsisakyti dalinimosi?",
					positiveActionTitle: "Atsisakyti dalinimosi",
					negativeActionTitle: "Atšaukti",
					positive: function(){
						this.deleteInAction = true;
						AtlasHelper.unshareAtlasWith(atlas["atlasID"]).then(function(){
							this.getList(); // FIXME: o gal užtektų tik pašalinti atlasą iš list'o?..
							this.deleteInAction = false;
						}.bind(this), function(){
							this.$vBus.$emit("show-message", "error");
							this.deleteInAction = false;
						}.bind(this));
					}.bind(this)
				};
				this.$vBus.$emit("confirm", e);
			},
			getAtlasType: function(atlasType){
				var atlasTypes = AtlasHelper.getAtlasTypes();
				if (atlasTypes) {
					atlasTypes.some(function(item){
						if (item.key == atlasType) {
							atlasType = item.name;
							return true;
						}
					});
				}
				return atlasType;
			},
			getShareType: function(shareType){
				var shareTypes = AtlasHelper.getSharingTypeItems();
				if (shareTypes) {
					shareTypes.some(function(item){
						if (item.key == shareType) {
							shareType = item.name;
							return true;
						}
					});
				}
				return shareType;
			},
			getImgSrc: function(){
				var imgSrc = null;
				if (this.atlas.images && this.atlas.images.length) {
					imgSrc = AtlasHelper.getImageUrl(this.atlas.atlasID, this.atlas.images[0].atlasImageID);
				}
				return imgSrc;
			}
		},
		watch: {
			checked: {
				immediate: true,
				handler: function(){
					if (this.onCheckStatusChange) {
						this.onCheckStatusChange();
					}
				}
			}
		}
	};
</script>

<style scoped>
	table {
		border-collapse: collapse;
	}
	td, th {
		border: 1px solid #cccccc;
		text-align: left;
		padding: 3px;
	}
	.thumbnail {
		width: 150px;
		height: 150px;
		border: 1px solid #dddddd;
	}
	.link {
		color: inherit;
		text-decoration: none;
	}
	.empty {
		background-color: #dedddd;
	}
    .paddingRightNone {
        padding-right: 0px;
    }
    .paddingRight5{
        padding-right: 5px;
    }
</style>